import { useQuery } from '@tanstack/react-query';

import { endpointGroupList } from '@api/sdk.gen';
import {
  EndpointgroupsEndpointGroupResponse,
  PoliciesGenericPolicy,
  PoliciesPolicyStatusBreakdown,
} from '@api/types.gen';

import {
  PolicyStatusBreakdown,
  TypedPolicy,
} from '@/react/portainer/policies/types';

import { EnvironmentGroup } from '../types';

import { queryKeys } from './query-keys';

/** Get all environment groups. **Only portainer administrators can access this endpoint.** */
export function useGroups<T = EnvironmentGroup[]>({
  select,
  enabled = true,
  size = false,
}: {
  select?: (group: EnvironmentGroup[]) => T;
  enabled?: boolean;
  size?: boolean;
} = {}) {
  return useQuery(
    queryKeys.list(size),
    async () => {
      const { data } = await endpointGroupList({ query: { size } });
      return data.map(toEnvironmentGroup);
    },
    {
      select,
      enabled,
    }
  );
}

export function toEnvironmentGroup(
  group: EndpointgroupsEndpointGroupResponse
): EnvironmentGroup {
  return {
    ...group,
    Policies: group.Policies.map(toPolicy) ?? [],
  };
}

function toPolicy(policy: PoliciesGenericPolicy): TypedPolicy {
  return {
    ...policy,
    EnvironmentTypes: policy.EnvironmentTypes ?? [],
    StatusBreakdown: toStatusBreakdown(policy.StatusBreakdown),
    Data: {},
  };
}

function toStatusBreakdown(
  status: PoliciesPolicyStatusBreakdown | undefined
): PolicyStatusBreakdown {
  return {
    Applied: status?.Applied ?? 0,
    Failed: status?.Failed ?? 0,
    InProgress: status?.InProgress ?? 0,
    NotSupported: status?.NotSupported ?? 0,
    Warning: status?.Warning ?? 0,
  };
}
